module.exports = __webpack_public_path__ + "static/img/safe@3x.1b108502.png";